<template lang="pug">
  b-navbar.header(:toggleable="toggleableValue", type="dark")
    button.sidebar-open-button(
      type="button",
      @click="toggleSidebar")
      icon(name="folder", scale="2")
    b-navbar-brand.logo.text-center.p-0
      div.ml-4
        router-link.logo-link(:to="{name: 'deviceAll', params: {groupPk: 'all'}}")
          img(src="../../../assets/main_logo-white.svg", :placeholder="`${AppState.Path.image}/main_logo_white.svg`", contain)
    b-navbar-toggle(target="nav_collapse")
    b-collapse#nav_collapse.collapse-wrap(is-nav).pl-3
      b-navbar-nav.nav
        b-nav-item(:to="{name: 'device-root'}")
          img(src="../../../assets/agent-icon.svg")
          span.text(v-t="'all-devices'")
        b-nav-item(:to="{name: 'application-root'}")
          icon(name="mobile-alt")
          span.text(v-t="'application'")
        b-nav-item(:to="{name: 'app-config-root'}")
          icon(name="cog")
          span.text(v-t="'config'")
        b-nav-item(:to="{name: 'management'}")
          img(src="../../../assets/user-icon.svg")
          span.text {{$t('account-manage')}}
        b-nav-item.d-none.d-md-block(v-if="(AppState.isCorporate && AppState.perm.isAdmin) || statistics", :to="{name: 'statistics'}")
          img(src="../../../assets/statistics-icon.svg")
          span.text {{$t('dashboard')}}
        b-nav-item.d-none.d-md-block(:to="{name: 'ticket-request'}" v-if="AppState.env.VUE_APP_TICKET_ENABLE")
          icon(name="cog")
          span.text(v-t="'access-ticket'")
        b-nav-item(:to="{name: 'support'}")
          img(src="../../../assets/download-icon.svg")
          span.text {{$t('download')}}
      b-navbar-nav.right-nav.ml-auto.d-flex.align-items-center
        // @@@ 토글부분
        //div.nowrap(style="margin-right: 1rem")
        //  span.mr-2(:class="simpleMode ? 'view-mode-simple' : 'view-mode-normal'") {{this.viewModeName}}
        //  switches.lmm-switch(
        //    v-model="simpleMode",
        //    theme="bootstrap",
        //    :color="simpleMode ? 'success' : 'default'"
        //  )
        div(v-if="AppState.perm.isAdmin")
          span.adminId.nowrap(v-t="'manager-id'" style="color: #FFFFFF")
        div(v-else-if="AppState.perm.isSubManager")
          span.adminId.nowrap(v-t="'sub-manager-id'" style="color: #FFFFFF")
        b-nav-item.d-lg-flex.language(@click="setDropdown('language', $event)")
          span.text.nowrap {{lang.current.text}}
          icon(name="caret-down")
          transition(name="dropdown")
            div.header-dropdown.select-language(v-if="dropdownState === 'language'")
              ul
                li(v-for="la in lang.options", :key="la.value", @click="selectLang(la)") {{la.text}}
        b-nav-item.logout(@click="logout")
          span.text.nowrap(v-t="'logout'")
</template>

<script>
import Switches from 'vue-switches'
import _ from 'lodash'
import {store} from '@/api/store'
import {logout, user} from '@/api/access'
import {DeviceAPI} from '@/api'
import {setPermission} from '../../../api/access'
import {getCurrentLanguage} from '@/i18n'
import {EventBus} from "../../manage/EventBus";

const checkDelay = {
  active: 12000,
  deactive: 1200000
}

export default {
  name: 'manager-header',
  components: { Switches },
  methods: {
    toggleSidebar () {
      this.AppState.Sidebar = !this.AppState.Sidebar
    },
    setDropdown (key, event) {
      event.stopPropagation()
      if (this.dropdownState === key) this.dropdownState = null
      else this.dropdownState = key
    },
    selectLang (lang) {
      // loadLanguageAsync(lang.value)
      // this.lang.current = lang
      let {name, params, query} = this.$route
      params.lang = lang.value
      this.$router.push({name, params, query})
    },
    getSummary (cb) {
      // if (!document.hasFocus()) return
      if (this.onProgress) return
      this.onProgress = true
      DeviceAPI
        .get('summary')
        .then(resp => {
          this.onProgress = false
          let newSum = resp.data.objects[0]
          let ticket = resp.data.meta
          if (!_.isEqual(this.summary, newSum)) {
            store.set('summary', newSum)
            this.AppState.$emit('summary-update', newSum)
            this.summary = newSum
            this.AppState.$emit('device-state-change')
            this.AppState.setSummary(newSum)
          }
          if (!_.isEqual(this.tickets, ticket)) {
            store.set('tickets', ticket)
            this.tickets = ticket
            this.AppState.setTicketSummary(ticket)
            this.AppState.$emit('ticket-state-change')
            if (cb) cb(ticket)
          }
          setPermission(this.user, true)
        })
    },
    getSummaryInterval () {
      if (this.checker.timer) clearInterval(this.checker.timer)
      this.getSummary()
      this.checker.timer = setInterval(() => {
        this.getSummary()
      }, this.checker.delay)
    },
    logout () {
      logout()
      // window.location.href = window.location.pathname || '/'
      const {lang} = this.$route.params
      this.$router.push({name: 'login', params: { lang }})
    },
    closeDropdown() {
      this.dropdownState = null
    },
  },
  created () {
    let stored = store.get('summary')
    this.simpleMode = store.get('icon_view')
    this.viewModeName = this.simpleMode ? "SIMPLE" : "NORMAL"
    if (stored) {
      this.summary = stored
      this.AppState.setSummary(stored)
    }

    let storedTicket = store.get('tickets')
    if (storedTicket) {
      this.tickets = storedTicket
      this.AppState.setTicketSummary(stored)
    }

    this.getSummary(ticket => {
      if (!storedTicket && ticket.request_ticket) {
        this.$awn.info(this.$t('has_request_ticket', {count: ticket.request_ticket}))
      }
    })
    this.getSummaryInterval()
    this.AppState.$on('logo-changed', () => {
      this.timestamp = new Date().getTime()
    })

    window.onblur = () => {
      this.checker.delay = checkDelay.deactive
      this.getSummaryInterval()
    }

    window.onfocus = () => {
      this.checker.delay = checkDelay.active
      this.getSummaryInterval()
    }

    let lang = this.$route.params.lang
    this.lang.current = _.find(this.lang.options, {value: lang})

    this.AppState.$on('app-logout', () => {
      this.logout()
    })
    this.currentLang = lang

    //통계탭 분기처리
    let authVal = this.user.auth_val
    authVal = authVal.split(',')
    for (var i = 0; i < authVal.length; i++) {
      if (authVal[i] == 8) {
        this.statistics = true
      } else {
        this.statistics = false
      }
    }
  },
  watch: {
    $route (r) {
      let lang = r.params.lang
      this.lang.current = _.find(this.lang.options, {value: lang})
      this.currentLang = lang
    },
    simpleMode(newValue) {
      store.set('icon_view', newValue)
      this.viewModeName = newValue ? "SIMPLE" : "NORMAL"
      EventBus.$emit('icon-view-changed', newValue)
      if (this.$route.path !== '/ko/device/all') {
        this.$router.push({name: 'device-root'})
      }
      this.AppState.isIconView = this.simpleMode;
      
      if (this.viewModeName === "SIMPLE") {
        store.set('rememberMode', 'card')
      } else if (this.viewModeName === "NORMAL") {
        store.set('rememberMode', 'table')
      }
    }
  },
  computed: {
    toggleableValue() {
      return this.currentLang === 'ko' ? 'xxl' : 'xxxl';
    }
  },
  mounted() {
    document.addEventListener('click', this.closeDropdown); // 전역 클릭 이벤트 리스너 등록
  },
  beforeDestroy () {
    window.onblur = null
    window.onfocus = null
    if (this.checker.timer) clearInterval(this.checker.timer)
    this.AppState.$off('logo-changed')
    document.removeEventListener('click', this.closeDropdown)
  },
  data () {
    const userData = user()
    let initDelay = document.hasFocus() ? checkDelay.active : checkDelay.deactive
    let currentLang = getCurrentLanguage()
    if (currentLang === 'ko') currentLang = 'kr'
    return {
      currentLang,
      onProgress: false,
      timestamp: 0,
      dropdownState: null,
      summary: null,
      tickets: null,
      checker: {
        timer: null,
        delay: initDelay
      },
      lang: {
        current: null,
        options: [
          { value: 'ko', text: 'KO' },
          { value: 'en', text: 'EN' },
          // { value: 'ja', text: 'JA' }
        ]
      },
      osIcons: ['desktop', 'brands/windows', 'brands/linux', 'brands/apple', 'brands/android', 'mobile'],
      user: userData,
      manual: `${this.AppState.Path.download}/manual/${currentLang}`,
      statistics: false,
      menuDevice: false,
      simpleMode: false,
      viewModeName: '',
    }
  },
}
</script>
<style lang="scss" scoped>
$nav-background-color: #232F3E;
@import 'src/bootstrap/functions';
@import 'src/bootstrap/variables';

.header {
    position: fixed;
    top: 0; left: 0;
    width: 100%; height: 68px;
    padding: 0;
    background-color: $nav-background-color;
    z-index: 1073;
    flex-flow: row nowrap;
}

@media (max-width: map-get($grid-breakpoints, xxxl)) {
  .header {
    flex-flow: wrap;
  }
  .navbar-toggler.collapsed,
  .navbar-toggler {
    margin-right: 10px;
  }
}

.footer {
    position: fixed;
    bottom: 0; left: 0;
    width: 100%; height: 30px;
    padding: 0;
    background-color: $nav-background-color;
    z-index: 1071;
}

.collapse-wrap {
  background-color: $nav-background-color;
}

.sidebar-open-button {
  border: 0;
  background-color: transparent;
  color: white;
  outline: none;
  @media (min-width: map-get($grid-breakpoints, xxl)) { display: none; }
}

.alert-count {
  transform: translate(-5px, -10px);
}

.logo {
  // 임시 패딩값 나중엔 중앙정렬
  padding-top: 7px;
  margin: 1.5rem;
  width: 170px; height: 20px;
  float: left;

  .logo-link {
    display: flex;
    width: 170px; height: 20px;
    align-items: center;
    justify-content: center;
  }
}

.os {
  display: inline-block;
  width: 60px;
  .os-icon {}
  .os-text {
    display: inline-block;
    padding: 0 10px;
  }
}
.os-wrap {
  cursor: default;
  border-top: 1px solid #ebebeb;
  background-color: #f0f0f0;
}
.status {
  cursor: default;
  .status-value {
    float: right;
  }
}
.header-dropdown {
  position: absolute;
  top: $content-margin-top; right: 0;
  ul {
    padding: 0;
    list-style: none;
    border: 1px solid #ebebeb;
    background-color: white;
    li {
      color: #888;
      padding: 0 20px;
    }
  }

  &.summary {
    ul {
      li {
        white-space: nowrap;
        min-width: 120px;
      }
    }
  }
}
.right-nav {
  > li {
    line-height: 50px;

    > a {
      display: block;
      padding: 0 1rem !important;
      height: $content-margin-top;
      color: #fff;
      font-size: 13px;
      // line-height: 60px;

      > svg { vertical-align: middle; }
      > .text {
        display: inline-block;
        padding: 0 5px;
        vertical-align: top;
      }
      
    }
    &.alert-icon {
      position: relative;
    }
    &.language {
      position: relative;
      @media (max-width: 768px) {
        > a {
          height: auto;
          .select-language {
            position: absolute;
            top: 100%;
            left: 0;
            right: auto;
            z-index: 999;
          }
        }
      }
    }
  }
}

.nav {
  > li {
    line-height: 50px;
    position: relative;
    > a {
      padding: 0 20px !important;
      height: $content-margin-top;
      color: #d6d6d6;
      font-size: 13px;
      display: flex;
      justify-content: center;
      align-items: center;

      > svg { vertical-align: middle; }
      > .text {
        display: inline-block;
        padding: 0 5px;
        vertical-align: top;
      }

      &:hover {
        // background-color: #555;
        color: $hover;
        // border-bottom: 4px solid #31b6ca;
        img {
          filter: invert(32%) sepia(85%) saturate(3550%) hue-rotate(178deg) brightness(95%) contrast(104%);
          //filter: invert(51%) sepia(52%) saturate(951%) hue-rotate(347deg) brightness(91%) contrast(104%);
          // invert(55%) sepia(47%) saturate(3800%) hue-rotate(355deg) brightness(96%) contrast(94%);
        }
      }

      &.nav-link.router-link-active {        
        color: $mainTheme;
        font-weight: 500;
        img {
          filter: invert(32%) sepia(85%) saturate(3550%) hue-rotate(178deg) brightness(95%) contrast(104%);
          //filter: invert(51%) sepia(52%) saturate(951%) hue-rotate(347deg) brightness(91%) contrast(104%);
        }
      }
    }
  }
  .drop-menu {
    position: absolute;
    top: $content-margin-top;
    left: 0;
    margin: 0;
    padding: 0;
    box-shadow: 0px 0px 7px 5px rgba(0, 0, 0, 0.2);
    border-radius: 2px;
    > li {
      list-style: none;
      background: #eee;
      width: 109px;
      text-align: center;
      border-radius: 2px;
      &:hover {
        color: #31b6ca;
      }
      &:hover a {
        color: #31b6ca;
      }
      > a {
        text-decoration: none;
        color: #232323;
      }
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-active {
  opacity: 0;
}

.adminId {
  color: $mainTheme;
  line-height: 50px;
  padding: 0 10px;
  font-size: 13px;
}

.download {
  color: #f1f1f1;
}

span.download {
  padding-left: 3px;
}

@media (max-width: 991px) {
  .mobile-language {
    border-top: 1px solid #5d5d5d;
  }
  .nav > li > a.nav-link{
    &.router-link-active {
      background-color: transparent;
      color: #31b6ca;
      font-weight: 500;
      border-bottom: 0px;
    }
    &:hover {
      background-color: transparent;
      color: #31b6ca;
      font-weight: 500;
      border-bottom: 0px;
    }
  }
}

.nav-link {
  display: flex !important;
  align-items: center;
}

.view-mode-simple {
  color: $mainTheme;
  font-size: 13px;
  font-weight: 400;
}

.view-mode-normal {
  color: #D2D2D2;
  font-size: 13px;
  font-weight: 400;
}

.select-language {
  > ul {
    background-color: #232F3E;
    border: #232F3E;
    > li {
      color: #D2D2D2 ;
    }
    > li:hover {
      color: #FFFFFF;
      background-color: #3A4A61;
    }
  }
}

.header-menu-icon {
  &:hover, &.active {
  filter: invert(51%) sepia(52%) saturate(951%) hue-rotate(347deg) brightness(91%) contrast(104%);  
  }
}

.new-badge {
  font-size: 0.8rem;
  margin-right: 0.4rem;
  margin-bottom: 0.7rem;
  animation: blink 1.5s infinite;
}

@keyframes blink {
  0% {
    opacity: 1;
  }
  30% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.nowrap {
  white-space: nowrap;
}
</style>